module.exports = __webpack_public_path__ + "img/6c558.35c621b5.svg";